import React from "react";
import { PageHero, CTABlock, SectionLabel } from "@/components/Sections";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ASSETS } from "@/lib/data";
import { Trash2, Calendar, Settings2 } from "lucide-react";

export default function Arbetsbodar() {
  return (
    <>
      <PageHero
        eyebrow="Företagstjänst"
        title="Städning av arbetsbodar"
        intro="Vi erbjuder daglig städning av arbetsbodar för både mindre och större etableringar. Arbetet planeras efter era tider och behov så att bodarna hålls rena och fungerande under hela projektet."
        image={ASSETS.workCabins}
        imageAlt="Städning av arbetsbod – Rena Tjänster"
      >
        <Link to="/kontakt#offertformular" data-testid="bodar-hero-cta">
          <Button className="bg-[#1E3A6F] hover:bg-[#152a51] text-white rounded-full px-7 py-6 font-medium">
            Begär offert
          </Button>
        </Link>
      </PageHero>

      <section className="py-20 lg:py-28" data-testid="bodar-content">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <SectionLabel className="mb-4">Planeras efter ert behov</SectionLabel>
          <h2 className="font-display text-3xl sm:text-4xl font-semibold tracking-tight text-slate-900 mb-6">
            Rena bodar – under hela projektet
          </h2>
          <p className="text-slate-600 leading-relaxed mb-4 max-w-3xl">
            Tillsammans kommer vi fram till hur ofta städningen ska utföras och vilka utrymmen som ingår.
            Vi anpassar oss efter etableringens storlek och projektets tidsplan.
          </p>
          <p className="text-slate-600 leading-relaxed mb-12 max-w-3xl">
            Vi kan även hjälpa till med sopor vid varje städtillfälle.
          </p>

          <div className="grid md:grid-cols-3 gap-5">
            {[
              { icon: Calendar, title: "Daglig städning", text: "Eller enligt önskat schema – vi anpassar oss." },
              { icon: Settings2, title: "Stora som små etableringar", text: "Vi har upplägg för båda." },
              { icon: Trash2, title: "Sopor inkluderat", text: "Vi kan ta hand om sopor vid varje städtillfälle." },
            ].map((b, i) => (
              <div key={i} className="bg-white rounded-2xl p-7 border border-slate-100" data-testid={`bodar-block-${i}`}>
                <div className="w-11 h-11 rounded-xl bg-[#1E3A6F]/8 text-[#1E3A6F] inline-flex items-center justify-center mb-4">
                  <b.icon className="h-5 w-5" strokeWidth={1.6} />
                </div>
                <h3 className="font-display text-lg font-semibold mb-1.5">{b.title}</h3>
                <p className="text-sm text-slate-600">{b.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTABlock
        title="Behöver ni regelbunden städning av arbetsbodar?"
        description="Berätta om etableringen så återkommer vi med ett upplägg och pris för det dagliga arbetet."
      />
    </>
  );
}
